export default __webpack_public_path__ + "static/media/avata.076a43fc.svg";